<template>
  <div class="PrintPosTkFcf">
    <div style="padding: 9px;">
      <div
        v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO RECHAZADO POR HACIENDA
        </h3>
      </div>
      <div
        v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO INVALIDADO POR HACIENDA
        </h3>
      </div>
      <table 
        :style="tableStyle"
      >
        <tr>
          <td
            style="
              font-size: 14pt;
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <b>{{
              dataProps.data.user.business != undefined ||
              dataProps.data.user.business != null
                ? dataProps.data.user.business.toUpperCase()
                : ""
            }}</b>
          </td>
        </tr>
        
        <tr v-if="isBranchBilledInfo">
           <td style="
              vertical-align: middle;
              width: 100%; 
              text-align: center;"
              v-html="modifiedBranchBilledInfo()"></td>
        </tr>
      </table>

      <table 
        :style="tableStyle"
      >
        <tr>
          <td style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "><b>N°: {{ dataProps.data.header.ID_Invoice }}</b></td>
        </tr>
        <tr>
          <td>
            <b>Cliente:</b>
            {{
              dataProps.data.header.ClienteNombreComercial
            }}
            <!--
            //dataProps.data.header.InvoiceName != undefined ||
              //dataProps.data.header.InvoiceName != null
              //  ? dataProps.data.header.InvoiceName.toUpperCase()
              //  : ""
            -->
          </td>
        </tr>
        
        <tr>
          <td>
            <b>Usuario impresion:</b>
            {{ user.firstName + ' ' + user.lastName || "---" }}
          </td>
        </tr>
        <tr>
          <td>
            <b>Fecha y hora de impresion:</b>
            {{ new Date().toLocaleString('es-ES') || "---" }}
          </td>
        </tr>
      </table>
      <hr/>
      <table  
        :style="tableStyle"
        >
        <tr>
          <td style="width: 25%;">Cant.</td>
          <td style="width: 25%;">P.<br/>Unit.</td>
          <td style="width: 25%;">Desc.<br/>Por Item</td>
          <td style="width: 25%;">SubTotal</td>
        </tr>
      </table>
      <table 
        :style="tableStyle"
      >
        <!-- Itera sobre cada item en dataProps.data.body -->
        <tr v-for="(item, index) in dataProps.data.body" :key="index">
          <hr/>
          <table :style="tableStyle">
          <tr>
            <td colspan="4">
              {{ item.ItemDescription + " " + (parseFloat(item.ItemGravada) > 0 ? "(G)" : "") + (parseFloat(item.ItemExenta) > 0 ? "(E)" : "") + (parseFloat(item.ItemNoSuj) > 0 ? "(NS)" : "") + (parseFloat(item.ItemNoGravada) > 0 ? "(NG)" : "") }}
              <i><b>Obs.: </b>{{ item.ItemComments }}</i>
            </td>
          </tr>
          <tr>
            <td style="width: 25%; text-align: center;">
              {{ item.ItemQuantity }}
            </td>

            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{
                (["CCF", "DNC", "DND"].includes(dataProps.data.header.InvoiceType)) ?
                (
                  (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(sumItemPriceWithIva(item.ItemUnitPrice, item.ItemIVA, item.ItemQuantity)))
                ) 
                : 
                (
                  (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(item.ItemUnitPrice))
                )
              }}
            </td>
            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{numberWithCommas(
                  parseFloat(item.ItemDiscount)
                )
              }}
            </td>
            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{
                (["CCF", "DNC", "DND"].includes(dataProps.data.header.InvoiceType)) ?
                (
                  parseFloat(item.ItemGravada) > 0 ? numberWithCommas(parseFloat(item.ItemGravada) + parseFloat(item.ItemIVA)) : ""
                ) 
                : 
                (
                  parseFloat(item.ItemGravada) > 0 ? numberWithCommas(parseFloat(item.ItemGravada)) : ""
                )
              }}
              {{parseFloat(item.ItemExenta) > 0 ? numberWithCommas(parseFloat(item.ItemExenta)) : ""}}
              {{parseFloat(item.ItemNoSuj) > 0 ? numberWithCommas(parseFloat(item.ItemNoSuj)) : ""}}
              {{parseFloat(item.ItemNoGravada) > 0 ? numberWithCommas(parseFloat(item.ItemNoGravada)) : ""}}
            </td>
          </tr>
          </table>
        </tr>
        
      </table>
      <hr />
      <table 
        :style="tableStyle"
      >
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoSuj)">
          <td style=" width: 75%">
            Suma No Sujeta:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoSuj
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalExenta)">
          <td style=" width: 75%">
            Suma Exento:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalExenta
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoGravado)">
          <td style=" width: 75%">
            Total otros montos no afectos:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoGravado
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalGravada)">
          <td style=" width: 75%">
            Suma Gravado:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{

              (["CCF", "DNC", "DND"].includes(dataProps.data.header.InvoiceType)) ?
                numberWithCommas(
                  parseFloat(
                    dataProps.data.header.InvoiceTotalGravada + dataProps.data.header.InvoiceTotalIva
                  )
                )
              : 
                numberWithCommas(
                    parseFloat(
                      dataProps.data.header.InvoiceTotalGravada
                    )
                  )
            }}
          </td>
        </tr>
      </table>

      <table 
        :style="tableStyle"
      >
        <!-- espacio en blanco al finalizar factura de ticket -->
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td style="border-width: 2px; text-overflow: ellipsis; overflow: hidden;">
            <div  
              style=" width: 100%; text-align: center; text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden;"
            >
              ------------------------------------------------------------------------------------------------------
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { formatNumber } from "../../helpers/money";

export default {
  name: "PrintPosFacturaTicketComandas",
  model: {
    event: "input",
    prop: "type",
  },
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      header: null,
      footer: null,
      loading: false,
      numPages: 0,
      mailLabel: null,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ticketformat3nstar: JSON.parse(localStorage.getItem("user")).ticketformat3nstar || 0,
      cash: 0,
      change: 0,
      tableStyle: {
        fontSize: '12pt',
        borderCollapse: 'collapse',
        width: '100%',
        verticalAlign: 'top',
        fontWeight: 500,
      }
    }
  },
  mounted() {
    console.log('this.user', this.user);
    this.showData()
    this.calculateTotalValues()
    //Font 12pt
    if(['ac296667317cfa35356801db4dc039b3'].includes(this.keyMaster)) {
      this.tableStyle.fontSize ='12pt';
    }
  },
  computed: {
    isBranchBilledInfo(){
      return this.dataProps.data.branch.BranchBilledInfo && 
              this.dataProps.data.branch.BranchBilledInfo != null && 
              this.dataProps.data.branch.BranchBilledInfo != '' && 
              this.dataProps.data.branch.BranchBilledInfo.trim().length > 0;
    }
  },
  watch: {
    "dataProps.show"() {},
  },
  methods: {
    stripHTML(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    async showData() {
      
        
          const partes = this.dataProps.data.header.InvoiceDate.split("/");
          const dia = partes[0];
          const mes = partes[1];
          const anio = partes[2];

          // Crear una nueva fecha en formato "yyyy-mm-dd"
          const fechaNueva = `${anio}-${mes}-${dia}`;
          const url =
            this.dataProps.data.branch.AuthFeMode == 1
              ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
              : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

          // Generar el código QR y mostrarlo en el elemento con id "qrcode"

          const opt = {
            errorCorrectionLevel: "H",
            type: "image/png",
            quality: 0.3,
            margin: 1,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
            width: 100,
          };

          QRCode.toDataURL(url, opt, (error, url) => {
            if (error) {
              console.log("Error al generar el código QR:", error);
              throw error;
            }

            this.urlQr = url;
          });
          await this.getImages();

      
    },
    numberWithCommas(x) {
      if(this.keyMaster === '55652726b965155654981d279f4900bf'){
        return formatNumber(x, 4)
      } 
      return formatNumber(x)
    },
    sumItemPriceWithIva(price, iva, qty) {
      const unitPrice = parseFloat(price) || 0;
      const totalIva = parseFloat(iva) || 0;
      const quantity = parseFloat(qty) || 0;

      if (quantity <= 0) {
        return unitPrice;
      }

      const ivaUnit = totalIva / quantity;

      return Math.ceil((unitPrice + ivaUnit) * 100) / 100;
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          // "tributos": null,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          // "tipoItem": 3,
          // "codTributo": null,
          uniMedida: item.ItemMeasureUnit,
          // "numeroDocumento": null,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async getImages() {
      try {
        const logo = this.dataProps.data.branch.BranchLogoPath;
        if (logo && logo !== 'null' && logo !== '') {
          // Usar el endpoint del backend que utiliza downloadFile de googleDriveDownload
          const response = await this.$API.utilities.downloadImageAsBase64({ imageUrl: logo });
          if (response && response.imageBase64) {
            this.dataProps.data.branch.BranchLogoPath = response.imageBase64;
          }
        }
      } catch (error) {
        console.error('Error al cargar la imagen:', error);
        // Mantener la URL original si hay error
      }
    },
    calculateTotalValues() {
      const invoicePayments = this.dataProps.data.invoicePayments || []
      const isHistoryFlow = invoicePayments.some((payment) => (
        Object.prototype.hasOwnProperty.call(payment, "DescriptionTypePayment") ||
        Object.prototype.hasOwnProperty.call(payment, "TotalPayment")
      ));
      const resolvePaymentCode = (payment) => {
        const code = payment?.typePayment
          ?? payment?.TypePayment
          ?? payment?.Codigo
          ?? payment?.codigo
          ?? payment?.code
          ?? payment?.Code;

        if (code !== undefined && code !== null && String(code).trim() !== "") {
          return String(code);
        }

        const description = String(
          payment?.descriptionPayment
          ?? payment?.DescriptionTypePayment
          ?? payment?.description
          ?? ""
        ).toLowerCase();

        return description.includes("billetes y monedas") ? "01" : "";
      };

      const resolvePaymentAmount = (payment) => {
        const value = payment?.totalPayment ?? payment?.TotalPayment ?? 0;
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue : 0;
      };

      const cashAmount = invoicePayments.reduce((sum, payment) => (
        resolvePaymentCode(payment) === "01"
          ? sum + resolvePaymentAmount(payment)
          : sum
      ), 0);

      const changeAmount = Number(this.dataProps.data.header.MoneyReturn || 0);
      this.change = parseFloat(changeAmount.toFixed(2));
      this.cash = parseFloat(
        (isHistoryFlow ? cashAmount + changeAmount : cashAmount).toFixed(2)
      );

      if (!invoicePayments.length && this.dataProps.data.header.InvoicePaymentType) {
        this.cash = parseFloat(
          Number(this.dataProps.data.header.InvoiceMontoTotalOperacion || 0).toFixed(2)
        );
      }
    }
    ,modifiedBranchBilledInfo() {
        const info = this.dataProps.data.branch.BranchBilledInfo
        if (this.isBranchBilledInfo) {
            return info
                .replace(/<p>/g, '')
                .replace(/<\/p>/g, '<br/>')
        }
        return null;
    },
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}
.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
}
.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

* {
  font-family: Arial, Helvetica, sans-serif !important;
  letter-spacing: 0.01px;
}
</style>
